module.exports = __webpack_public_path__ + "static/media/NewScreen2.22a7069b.png";